import { Link, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from 'axios';
import config from "../../Common/Configurations/APIConfig";
import LayoutHeader from "../../Common/Layout/Header";
import LayoutSideBar from "../../Common/Layout/Sidebar";
export default function RejectedLenders() {
    const params = useParams();
    const [lists, setLists] = useState([]);
    const [applications, setApplications] = useState([]);
    const [lenders, setLenders] = useState([]);
    const [lenderApplicationId, setLenderApplicationId] = useState("00000000-0000-0000-0000-000000000000");
    const [clientId, setClientId] = useState("00000000-0000-0000-0000-000000000000");//for only clients login
    const [lenderId, setLenderId] = useState("00000000-0000-0000-0000-000000000000");
    const [btnSubmit, setBtnSubmit] = useState(false);
    const [totalPages, setTotalPages] = useState(0);
    const [pageSize, setPageSize] = useState(20);
    const [pageNumber, setPageNumber] = useState(1);
    const [data, setData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [loading, setLoading] = useState(false);
    const headerconfig = {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("userToken"),
            "Content-Type": "application/json"
        }
    }
    const GetLastPageData = () => {
        GetData(totalPages)
    }
    const GetFirstPageData = () => {
        GetData("1")
    }
    const GetPageData = (number) => {
        setPageNumber(number);
        if (pageNumber !== number)
            GetData(number)
    }
    const pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
    }
    const renderPageNumbers = pageNumbers.map((number) => {
        return (
            <li className="page-item" key={number} id={number} onClick={() => GetPageData(number)}>
                <Link className="page-link">{number}</Link>
            </li>
        );
    });
    const GetData = (number) => {
        setLoading(true);
        axios
            .get(config.APIACTIVATEURL + config.GETAPPLICATIONLENDERBYSTATUS + "?status=REJECTED&lendingApplicationId=" + lenderApplicationId + "&lenderId=" + lenderId + "&clientId=" + clientId + "&pageNumber=" + number + "&pageSize=" + pageSize + "", { ...headerconfig })
            .then((response) => {
                if (response.status === 200) {
                    setLists(response.data.data.data);
                    setPageNumber(response.data.data.pageNumber);
                    setPageSize(response.data.data.pageSize);
                    setTotalPages(response.data.data.totalPages);
                    setData(response.data.data);
                    setTotalRecords(response.data.data.totalRecords);
                }
                setLoading(false);
            });
    };
    const handleSearch = () => {
        GetData(pageNumber);
    };
    const resetForm = () => {
        GetData(pageNumber);
    };
    const GetApplications = () => {
        axios
            .get(config.APIACTIVATEURL + config.GETALLLENDINGAPPLICATIONS, { ...headerconfig })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    setApplications(response.data.data);
                }
            });
    };
    const GetLenders = () => {
        axios
            .get(config.APIACTIVATEURL + config.GETALLLENDERS, { ...headerconfig })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    setLenders(response.data.data);
                }
            });
    };
    useEffect(() => {
        GetData(pageNumber);
        GetApplications();
        GetLenders();
        if (localStorage.getItem("roleName") === "CLIENT") {
            setClientId(localStorage.getItem("clientId"));
        }
    }, [])
    return (
        <div id="layout-wrapper">
            <LayoutHeader></LayoutHeader>
            <LayoutSideBar></LayoutSideBar>
            <div className="body-wrapper">
                <div className="container-fluid">
                    <div class="card card-body py-3">
                        <div className="row mb-3 mt-3">
                            <div style={{ width: "20%" }}>
                                <label className="form-label" htmlFor="clients">Clients</label>
                                <select className="form-select" onChange={(e) => setLenderApplicationId(e.target.value)} value={lenderApplicationId} name="lenderApplicationId">
                                    <option value={"00000000-0000-0000-0000-000000000000"}>All Applications</option>
                                    {applications.length > 0 && applications.map(c =>
                                        <option value={c.lendingApplicationId}>{c.businessLegalName}</option>
                                    )}
                                </select>
                            </div>
                            <div style={{ width: "20%" }}>
                                <label className="form-label" htmlFor="lenders">Funders</label>
                                <select className="form-select" onChange={(e) => setLenderId(e.target.value)} value={lenderId} name="lenderId">
                                    <option value={"00000000-0000-0000-0000-000000000000"}>All Funders</option>
                                    {lenders.length > 0 && lenders.map(c =>
                                        <option value={c.lenderId}>{c.companyName}</option>
                                    )}
                                </select>
                            </div>
                            <div style={{ width: "20%" }}>
                                <div className="hstack gap-2 justify-content-end mb-3 mt-4">
                                    {loading === true ?
                                        <button type="button" className="btn btn-success" disabled>Loading..</button>
                                        :
                                        <button type="button" className="btn btn-success" onClick={handleSearch}>Search</button>}
                                    <button type="button" className="btn btn-danger" onClick={resetForm}>Clear</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card w-100 position-relative overflow-hidden">
                                <div className="px-4 py-3 border-bottom">
                                    <h4 className="card-title mb-0">Rejected Funders Report</h4>
                                </div>
                                <div className="card-body p-4">
                                    <div className="table-responsive table-card">
                                        <table className="table align-middle" id="customerTable">
                                            <thead className="table-light">
                                                <tr>
                                                    <th>Id</th>
                                                    <th>Client</th>
                                                    <th>Funder</th>
                                                    <th>Amount</th>
                                                    <th>Status</th>
                                                    <th>Reason</th>
                                                </tr>
                                            </thead>
                                            <tbody className="list form-check-all">
                                                {lists.length > 0 && lists.map((v, index) =>
                                                    <tr key={v.lenderApplicationId}>
                                                        <td>{index + 1}</td>
                                                        <td>{v.businessName}</td>
                                                        <td>{v.companyName}</td>
                                                        <td>USD {v.amount}</td>
                                                        <td><span className="badge bg-danger">REJECTED</span></td>
                                                        <td>{v.reason}</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="align-items-center mt-4 pt-2 justify-content-between d-flex">
                                        <div className="flex-shrink-0">
                                            <div className="text-muted">
                                                Showing <span className="fw-semibold">{lists.length}</span> of <span className="fw-semibold">{totalRecords}</span> Results
                                            </div>
                                        </div>
                                        <ul className="pagination pagination-separated pagination-sm mb-0">
                                            <li className={"page-item" + data.previousPage === null ? 'disabled' : ''} onClick={() => GetFirstPageData()}>
                                                <Link className="page-link">Previous</Link>
                                            </li>
                                            {renderPageNumbers}
                                            <li className={"page-item" + data.nextPage === null ? 'disabled' : ''} onClick={() => GetLastPageData()}>
                                                <Link className="page-link">Next</Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div> {/* .card*/}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}